/**
 * Quick Create allowlist — legacy QT_* with purposeful Agent recipes.
 *
 * EMG-GQ-ENUM-CATALOG: AI dropdown = QuestionTypeEnum (`interactionCatalog`).
 * Quick Create is NOT “everything else” — only templates that ship a real
 * purpose in Agent `question_catalog.json`:
 *   - non-empty `recipe.prompt` / `set_prompt`, OR
 *   - blueprint `set(stimulus + leaf)`, OR
 *   - leaf task settings (`speak_task` / `write_task`)
 */

/** Agent catalog / Hub `AIContentType.code` values for Tạo nhanh. */
export const QUICK_CREATE_CODES = [
    'QT_FILL_BLANK_DRAG',
    'QT_IMAGE_WORD',
    'QT_IMAGE_YESNO',
    'QT_LISTEN_COLOR_OBJECTS',
    'QT_LISTEN_CONV_TICK',
    'QT_LISTEN_DICTATION',
    'QT_LISTEN_HIGHLIGHT_INCORRECT_WORDS',
    'QT_LISTEN_HIGHLIGHT_SUMMARY',
    'QT_LISTEN_MATCH_LINE',
    'QT_LISTEN_MCQ',
    'QT_LISTEN_MCQ_MULTI',
    'QT_LISTEN_MISSING_WORD',
    'QT_LISTEN_SUMMARIZE',
    'QT_LISTEN_WRITE',
    'QT_LISTEN_WRITE_LETTER',
    'QT_LOOK_READ_TICK_CROSS',
    'QT_MATCHING',
    'QT_PARA_FILL_GIVEN',
    'QT_PASSAGE_MCQ',
    'QT_PIC_LETTER_WORD',
    'QT_READ_MCQ_MULTI',
    'QT_READ_REORDER',
    'QT_READ_WRITE_OWN',
    'QT_SPEAK_ANSWER_SHORT_QUESTION',
    'QT_SPEAK_READ_ALOUD',
    'QT_SPEAK_REPEAT_SENTENCE',
    'QT_SPEAK_RESPOND_SITUATION',
    'QT_SPEAK_RETELL_LECTURE',
    'QT_SPEAK_SUMMARIZE_GROUP_DISCUSSION',
    'QT_VERB_TENSE',
    'QT_WRITE_ESSAY',
    'QT_WRITE_SUMMARIZE_WRITTEN_TEXT',
] as const;

export type QuickCreateCode = (typeof QUICK_CREATE_CODES)[number];

/** Hub slug form: ``QT_LISTEN_MCQ`` → ``qt-listen-mcq``. */
export function quickCreateCodeToSlug(code: string): string {
    return code.trim().toLowerCase().replace(/_/g, '-');
}

const _ALLOWED_SLUGS = new Set(QUICK_CREATE_CODES.map(quickCreateCodeToSlug));
const _ALLOWED_CODES = new Set<string>(QUICK_CREATE_CODES);

export function isQuickCreateAllowed(slugOrCode: string): boolean {
    const key = (slugOrCode || '').trim();
    if (!key) return false;
    if (_ALLOWED_CODES.has(key) || _ALLOWED_SLUGS.has(key)) return true;
    // Accept uppercase slug typos / mixed
    const asSlug = key.toLowerCase().replace(/_/g, '-');
    return _ALLOWED_SLUGS.has(asSlug);
}

export function getQuickCreateSlugs(): string[] {
    return QUICK_CREATE_CODES.map(quickCreateCodeToSlug);
}
